// extracted by mini-css-extract-plugin
export var dataCell = "_ng-2";
export var dataRow = "_ng-0";
export var headerRow = "_ng-1";